import React, { useState } from 'react'

import { Col, Row } from 'react-bootstrap'
import { Card, FormText, Icon } from 'src/components'

import { IDataForm } from 'src/content/CardProviders/CardProvider/Forms/Pagalo/CardPagaloForm'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'

export const PagaloCredentials = ({ data, onChange }: IDataForm) => {
  const [toggle, setToggle] = useState<boolean>(false)

  return (
    <Card white title={'Credenciales'}>
      <Row>
        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
          <FormText
            label={'Correo electrónico'}
            value={data.email}
            name={'email'}
            required
            type={'email'}
            onChange={onChange}
          />
        </Col>
        <Col xl={6} lg={6} md={6} sm={12} xs={12}>
          <FormText
            label={'Contraseña'}
            value={data.password}
            name={'password'}
            required
            type={toggle ? 'text' : 'password'}
            onChange={onChange}
            append={
              <Icon
                icon={!toggle ? faEye : faEyeSlash}
                tooltip={toggle ? 'ocultar' : 'Ver'}
                onClick={() => setToggle(!toggle)}
              />
            }
          />
        </Col>
      </Row>
    </Card>
  )
}
